import { ManagedContentBanner } from '@seek/cms-ui';
import type { Locale } from '@seek/melways-sites';
import React, { type ComponentProps } from 'react';
import { ErrorBoundary } from 'react-error-boundary';

import { getLogger } from 'src/App/utils/logger/logger';
import { useAppContext } from '../../context/AppContext';
import {
  type Environment,
  isLocal,
  isServerRendering,
} from '../../services/environment';
import { useLanguage } from '@vocab/react';

export type SystemBannerContext =
  | 'ad_budget_product_page'
  | 'ad_budget_checkout_page';

const getEnvironment = (environment: Environment) => {
  if (isLocal(environment)) {
    return 'development';
  }
  if (environment === 'staging') {
    return 'staging';
  }
  return 'production';
};

export const SystemBanner = ({
  context,
}: {
  style?: ComponentProps<typeof ManagedContentBanner>['style'];
  context: SystemBannerContext;
}) => {
  const { environment } = useAppContext();
  const { language } = useLanguage();
  const logger = getLogger();

  return (
    <ErrorBoundary
      fallbackRender={() => null}
      onError={(error) => {
        logger.error('SystemBanner | Failed to render', {
          error,
          context,
          language,
        });
      }}
    >
      {!isServerRendering() && !isLocal(environment) ? (
        <ManagedContentBanner
          locale={language as Locale}
          platform="employer"
          environment={getEnvironment(environment)}
          context={context}
        />
      ) : null}
    </ErrorBoundary>
  );
};
